<template>
	<div class="setting-page">
		<a-spin :spinning="loading">
			<div class="ft20 cl-main ftw600">{{title}}</div>
			
			<div class="mt20 bg-w pd40">
				<div style="width: 1000px;">
					<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-form-model-item required label="店铺Logo">
							<select-file v-model="fileList" :isSingle="true"></select-file>
						</a-form-model-item>
						<a-form-model-item required label="门店名称">
							<a-input v-model="form.name" placeholder="输入门店名称" style="width: 400px;"></a-input>
						</a-form-model-item>
						<a-form-model-item required label="门店电话">
                            <a-input-group compact>
                                <a-input style="width:60px;" placeholder="区号" v-model="form.area_code"  />
                                <a-input  style="width:120px;" placeholder="电话号码" v-model="form.tel"  />
                            </a-input-group>
						</a-form-model-item>
						<a-form-model-item required label="营业时间">
							<a-input v-model="form.business_hours" placeholder="例周一至周日 08:00-20:00" style="width: 400px;"></a-input>
						</a-form-model-item>
                        <a-form-model-item required label="所属区域">
                            <a-cascader
                                :options="options"
                                :default-value="region"
                                @change="onChangeRegion"
                                placeholder="请选择区域"
                                style="width: 300px;"
                            />
                        </a-form-model-item>
						<a-form-model-item required label="门店详细地址">
							<a-input v-model="form.address"  placeholder="输入门店详细地址" style="width: 400px;"></a-input>
						</a-form-model-item>
						<a-form-model-item required label="门店简介">
							<a-input v-model="form.content"  placeholder="输入门店简介" type="textarea"></a-input>
						</a-form-model-item>
						<a-form-model-item required label="门店定位">
							<div class="flex alcenter">
								<a-input :value="form.lat + ',' + form.lng" disabled style="width: 200px; margin-right: 10px; color: #000000;"></a-input>
								<baidu-map :lat="form.lat" :lng="form.lng" @select="selectAct"></baidu-map>
							</div>
						</a-form-model-item>
						<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                            <a-button type="primary" @click="onSubmit" :loading="confirmLoading">
                                确定保存
                            </a-button>
						</a-form-model-item>
					</a-form-model>	
					
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script>
    import region from '@/assets/js/region.js';
	import selectFile from '@/components/select.vue';
	import BaiduMap from '../../../components/map/baidumap.vue';
	export default{
		components:{
			selectFile,
			BaiduMap
		},
		data(){
			return {
				loading:false,
				confirmLoading:false,
				labelCol: { span: 4 },
                wrapperCol: { span: 14 },
                options: [],
                shopId: 0,
                oldShopName: '',
                fileList: [],
				form: {
                    lat: '',
                    lng: '',
                },
                region: [],
                title: ''
			}
		},
		created() {
            this.options = region.map;
            if (!this.$route.query.shop_id) {
				this.shopId=0;
                this.title = '添加店铺';
			} else {
				this.shopId = parseInt(this.$route.query.shop_id);
                this.title = '修改店铺';
			}
			this.loaddata();
		},
		methods:{
			loaddata(){
                if(this.shopId == 0){
					return ;
				}
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('platform/shop/getShopDetail',{
					shop_id: this.shopId
				}).then(res=>{
					if(res.details){
						this.form = res.details;
                        if(res.details.file){
                            this.fileList.push(res.details.file);
                        }
                        this.oldShopName = res.details.name;
						if(res.details.province_id > 0){
							this.region.push(res.details.province_id);
							this.region.push(res.details.city_id);
							this.region.push(res.details.area_id);
						}
						if(res.details.tel !== ''){
							let telArr = res.details.tel.split('-');
							this.form.area_code = telArr[0];
							this.form.tel = telArr[1];
						}
					}
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
					this.$router.go(-1);
				})
			},
            onChangeRegion(value) {
				this.region = value;
			},
            getFileList(){
				if(this.fileList.length>0){
					return this.fileList[0].file_id
				}
				return 0;
			},
			onSubmit() {
                if(this.fileList.length == 0){
					this.$message.error('请选择店铺logo');
					return false;
				}
                if(this.form.name == ''){
					this.$message.error('请填写店铺名称');
					return false;
				}
				if(this.form.tel == ''){
					this.$message.error('请填写店铺联系方式');
					return false;
				}
                if(this.form.business_hours == ''){
                    this.$message.error('请填写店铺营业时间');
					return false;
                }
                if(this.region.length == 0){
                    this.$message.error('选择区域信息');
					return false;
                }
                if(this.form.address == ''){
                    this.$message.error('请填写店铺详细地址');
					return false;
                }
                if(this.form.content == ''){
                    this.$message.error('请填写店铺简介');
					return false;
                }
                if(this.form.lat == '' ||  this.form.lng == ''){
					this.$message.error('请选择店铺定位');
					return false;
				}
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
                console.log(this.region);
                if(this.region.length > 0){
					this.form.province_id = this.region[0];
					this.form.city_id = this.region[1];
					this.form.area_id = this.region[2];
				}
				this.$http.api('platform/shop/addShop',{
                    shop_id: this.shopId,
					old_shop_name: this.oldShopName,
                    name: this.form.name,
                    logo_id: this.getFileList(),
					logo: this.fileList[0].file_path,
					door_license_plate:this.form.door_license_plate,
					business_hours:this.form.business_hours,
					tel: this.form.area_code && this.form.tel ? (this.form.area_code +'-'+ this.form.tel) : '',
                    province_id: this.form.province_id,
					city_id: this.form.city_id,
					area_id: this.form.area_id,
					address:this.form.address,
					content: this.form.content,
					lng:this.form.lng,
					lat:this.form.lat,
				}).then(res=>{
					this.$message.success('保存成功',1,()=>{
						this.confirmLoading=false;
						this.$router.push('/setting/shop');
					})
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},
			selectAct(e){
				this.form.lat = e.lat;
				this.form.lng = e.lng;
			}
		}
	}
</script>

<style>
	.setting-page{
		min-width: 1080px;
	}
</style>